export default {
    "pumps": {
        "title": "Pumps Speed Control & Staging",
        "linkTitle": "Pumps Speed Control & Staging",
        "viewType": "plot-list",
        "hidden":true,
        "hasEquipmentSelector": false,
        "plotList":
            [
                {
                    'id': 1,
                    'flex-class':'md6',
                    'type': 'data2-chart',
                    'config': {
                        'layout-overrides': {
                            title:'VFD Control',
                            xaxis: {
                                title: "Time "
                            },legend: {
                                orientation: 'h',
                                y:-0.2
                            },
                            margin:{
                                l: 50,
                                r: 50,
                                t: 30,
                                pad: 1
                            },
                        },
                        'data-payload': {
                            'filters': {
                                'sensor_names': ["VFD_Control"],
                                "equipment_type": "SCP",
                            }
                        },
                    }
                },
                {
                    'id': 2,
                    'flex-class':'md6',
                    'type': 'data2-chart',
                    'config': {
                        'layout-overrides': {
                            title:'On',
                            xaxis: {
                                title: "Time "
                            },legend: {
                                orientation: 'h',
                                y:-0.2
                            },
                            margin:{
                                l: 50,
                                r: 50,
                                t: 30,
                                pad: 1
                            },
                        },
                        'data-payload': {
                            'filters': {
                                'sensor_names': ["on"],
                                "equipment_type": "SCP",
                            }
                        },
                        'series-overrides':{
                            stackgroup: 'one',
                            mode: 'none',
                        },
                    }
                },
                {
                    'id': 95,
                    'type': 'multi-chart',
                    'flex-class':'md6',
                    'config': {
                        'layout-overrides': {
                            title:"Header Differential Pressure",
                            xaxis: {
                                title: "Time "
                            },
                            yaxis: {
                                title: "Pressure (kPa)"
                            },legend: {
                                orientation: 'h',
                                y:-0.2
                            },
                            margin:{
                                l: 50,
                                r: 50,
                                t: 30,
                                pad: 1
                            },
                        },
                        'variables-list': [
                            {
                                equipment_name: "Header_SCP",
                                name: "Diff_pressure",
                            },
                            {
                                equipment_name: "Header_SCP",
                                name: "Diff_Pressure_SP",
                            }
                        ],
                    }
                },
                {
                    'id': 123,
                    'type': 'data2-chart',
                    'flex-class':'md6',
                    'config': {
                        'layout-overrides': {
                            title:'AHU Cooling Valve Feedback',
                            xaxis: {
                                title: "Time "
                            },legend: {
                                orientation: 'h',
                                y:-0.2
                            },
                            margin:{
                                l: 50,
                                r: 50,
                                t: 30,
                                pad: 1
                            },

                        },
                        'data-payload': {
                            'filters': {
                                'sensor_names': ["Cooling_Valve_Feedback"],
                                "equipment_type_regex": "^ahu",
                            }
                        },
                    }
                },
                {
                    'id': 6,
                    'flex-class':'md6',
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title:"Header Flow",
                            xaxis: {
                                title: "Time "
                            },
                            yaxis: {
                                title: "Flow Rate (L/s)"
                            },legend: {
                                orientation: 'h',
                                y:-0.2
                            },
                            margin:{
                                l: 50,
                                r: 50,
                                t: 30,
                                pad: 1
                            },
                        },
                        'variables-list': [
                            {
                                equipment_name: "Header_SCP",
                                name: "CHW_Flow_Rate",
                            }
                        ],
                    }
                },
                {
                    'id': 9,
                    'type': 'multi-chart',
                    'flex-class':'md6',
                    'config': {
                        'layout-overrides': {
                            title:"Header Chilled Water Temperature",
                            xaxis: {
                                title: "Time "
                            },
                            yaxis: {
                                title: "Temperature (°C)"
                            },legend: {
                                orientation: 'h',
                                y:-0.2
                            },
                            margin:{
                                l: 50,
                                r: 50,
                                t: 30,
                                pad: 1
                            },
                        },
                        'variables-list': [
                            {
                                equipment_name: "Header_SCP",
                                name: "CHWR_Temp",
                            },
                            {
                                equipment_name: "Header_SCP",
                                name: "CHWS_Temp",
                            }
                        ],
                    }
                },

            ]
    },
    "cooling-load": {
        "title": "Cooling Load",
        "linkTitle": "Cooling Load",
        "viewType": "plot-list",
        "hasEquipmentSelector": false,
        "hidden":true,
        "plotList":
            [
                {
                    'id': 2,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title:"Power Consumption",
                            xaxis: {
                                title: "Outdoor Temperature (°C)"
                            },
                            yaxis: {
                                title: "Cooling Load (kW))"
                            }
                        },
                        type: 'scatter',
                        'variables-list': [
                            {
                                equipment_name: "Weather",
                                mode: "markers",
                                name: "Outdoor_Temperature",
                                useAsXVariable: true
                            },
                            {
                                equipment_name: "Header_SCP",
                                mode: "markers",
                                name: "Cooling_Load",
                            }



                        ],
                    }
                },
                {
                'id': 9,
                'type': 'multi-chart',
                'config': {
                    'layout-overrides': {
                        title:"Cooling Load",
                        xaxis: {
                            title: "Time "
                        },
                        yaxis: {title: 'Cooling Load (kW)'},
                        legend: {
                            orientation: 'h',
                            y:-0.2
                        },
                        margin:{
                            l: 50,
                            r: 50,
                            t: 30,
                            pad: 1
                        },
                    },
                    type: 'scatter',
                    'variables-list': [
                        {
                            equipment_name: "Header_SCP",
                            stackgroup: 'one',
                            mode: 'none',
                            name: "Cooling_Load",
                        }
                    ],
                }
            },]
    }
};
